import { Component } from '@angular/core';
import { events } from '../../../_data/events';
import * as moment from 'moment';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
})
export class EventsComponent {
  // Events Init
  events = events;
  eventsInit = [];
  today = moment();

  // Sorting Events
  showEvents() {
    this.eventsInit = [];
    for (let i = 0; i < this.events.length; i++) {
      const isAfter = moment(this.today).isAfter(this.events[i].date);
      // console.log(isAfter);
      if (isAfter === false) {
        this.eventsInit.push(this.events[i]);
        this.eventsInit[this.eventsInit.length - 1].day = moment(
          this.events[i].date
        ).format('D');
        this.eventsInit[this.eventsInit.length - 1].month = moment(
          this.events[i].date
        ).format('MMMM');
      }
    }
    // console.log(this.eventsInit);
  }

  constructor() {
    this.showEvents();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/home/events/events.component.ts